import React, { useEffect, useState } from 'react';
import { track } from '../lib/track';
import { partnerTier } from '../lib/analyticsIdentity';

const STORAGE_KEY = 'eagle_vdr_intent_survey_v1';
const DELAY_MS = 10 * 60 * 1000;

const CHOICES = [
  { id: 'bid', label: 'Set / stress a bid' },
  { id: 'wells', label: 'Diligence a well' },
  { id: 'evidence', label: 'Find evidence / logs' },
  { id: 'crm', label: 'Capital / CRM' },
  { id: 'explore', label: 'Explore the desk' },
  { id: 'other', label: 'Other' },
];

function alreadyAskedToday() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    const { day } = JSON.parse(raw);
    return day === new Date().toISOString().slice(0, 10);
  } catch {
    return false;
  }
}

function markAsked() {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ day: new Date().toISOString().slice(0, 10) }),
    );
  } catch {
    /* ignore */
  }
}

/**
 * Optional micro-survey after 10+ min authenticated session (once/day).
 * Partners only — not internal desk spam.
 */
export default function SessionIntentSurvey({ user, enabled }) {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState('');

  useEffect(() => {
    if (!enabled || !user) return undefined;
    if (partnerTier(user) !== 'partner') return undefined;
    if (alreadyAskedToday()) return undefined;
    const t = setTimeout(() => setOpen(true), DELAY_MS);
    return () => clearTimeout(t);
  }, [enabled, user]);

  if (!open) return null;

  function dismiss(reason) {
    markAsked();
    track('session_intent_survey', { outcome: reason });
    setOpen(false);
  }

  function submit(choiceId) {
    markAsked();
    track('session_intent_survey', {
      outcome: 'answered',
      intent: choiceId,
      note_len: note.trim().length,
      // Cap free text — never dump long CA narrative.
      note: note.trim().slice(0, 120) || undefined,
    });
    setOpen(false);
  }

  return (
    <div className="intent-survey" role="dialog" aria-label="Session intent">
      <div className="intent-survey-card">
        <div className="intent-survey-title">Quick check — what were you trying to decide?</div>
        <p className="intent-survey-sub">Optional · helps us prioritize the desk · once a day</p>
        <div className="intent-survey-choices">
          {CHOICES.map((c) => (
            <button key={c.id} type="button" className="btn-secondary" onClick={() => submit(c.id)}>
              {c.label}
            </button>
          ))}
        </div>
        <label className="intent-survey-note">
          <span>Optional note (≤120 chars)</span>
          <input
            type="text"
            maxLength={120}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="e.g. Boswell OH / first-prod"
          />
        </label>
        <button type="button" className="intent-survey-dismiss" onClick={() => dismiss('dismissed')}>
          Not now
        </button>
      </div>
    </div>
  );
}
